// 获取用户的导航与角色权限；
import getRoleAndNavigation from '@/utils/getRoleAndNavigation'
import Layout from "@/layout";
import Index from "@/views/Home/Index"; // 主题二首页
import serviceNewV2 from "@/views/Service/serviceNewV2";
import Tourist from "@/views/Home/Tourist";
import Visitor from "@/views/Home/Visitor";
import Teacher from "@/views/Home/Teacher";
import Student from "@/views/Home/Student";
import Service from "@/views/Service/index";
import Events from "@/views/Events/index";
import NewsNew from "@/views/NewsNew/index";
import News from "@/views/News/index";
import BusinessManagement from "@/views/BusinessManagement/index";
import Schedule from "@/views/Schedule/index";
import store from "@/store";

import 'systemjs'
import 'systemjs/dist/extras/use-default.js'
// 引入加载远程组件函数
import {loadRemotePage} from '@/utils/loadRemoteComponent';

let getHomeModulesRouter = async()=> {
  await getRoleAndNavigation();
  let userNav = store.getters.userNav;
  let navRouters = [];
  let setObj={
    "ServiceCenter":serviceNewV2, // 服务中心(主题二)
    "ServiceCenter1":Service, // 服务中心(主题一)
    "EventsCenter":Events, // 事务中心
    "NewsCenter":NewsNew, // 资讯中心(主题二)
    "NewsCenter1":News, // 资讯中心(主题一)
    "BusinessManagementCenter":BusinessManagement, // 业务管理中心
    "ScheduleCenter":Schedule, // 日程中心
    "Visitor":Visitor, // 风格一访客首页
    "Teacher":Teacher, // 风格一教师首页
    "Student":Student, // 风格一学生首页
    "Tourist":Tourist, // 风格一学生首页
  }
  userNav.forEach( nav => {
    let router = {
      name:nav.pageCode,
      path:nav.pageCode,
      meta: { title: nav.pageName },
      component: async()=> {
        let Module = null;
        if(nav.resourceUrl) {
          // 定制
          try{
            Module = await loadRemotePage(nav.pageCode);

          }catch(e){
            console.error(e)
          }
        }else {
          // 产品
          if (nav.pageCode.startsWith('Index')) {
            Module = Index;
          } else {
            Module = setObj[nav.pageCode]
          }
        }
        return  Module
      },
    }
    if(nav.pageCode === 'NewsCenter') {
      router.beforeEnter = (to, from, next) => {
        // 如果是跳转到资讯中心，资讯中心路由添加参数fromRouter，否则为自我刷新，不做处理
        if(from.name) {
          to.params.fromRouter = 1;
        }
        next();
      }
    }

    navRouters.push(router)
  })

  const ModulesRouter = {
    name: "Home",
    path: "/",
    component: Layout,
    commonWhiteNav:["BusinessManagementCenter","SignIn","Tourist","AddNetworkAccount","Logout","ServiceCenter","NewsCenter", "NewsDetail",
      "HelpCenter","ContentReleaseRedHead","CreateApplication","CreateService", "EditApplication", "EditService", "ViewApplication",
      "ViewService","ShelfApplicationService","AddTerminal","ServiceInfo","ApplicationInfo","DataInfo",
      "DataView","DataShareMe","GlobalSearch","PersonalCenter","Information","SafeConfig","UnionLogin","LoginHistory","MyCollections","MyMessage",
      "MyCost","addressCard","Agent","MessagesCenter",'blankData', 'MailRegistry',"CardShow"],
    children: [
      {
        name: "SignIn",
        path: "signin",
        component: () => import("@/views/Sign"),
        meta: { title: "登录" }
      },

      {
        name: "CardShow",
        path: "CardShow",
        component: () =>
          import("@/views/Cards/index"),
        meta: { title: "卡片" }
      },
      {
        name: "AddNetworkAccount",
        path: "AddNetworkAccount",
        component: () =>
          import("@/views/Home/Modules/HotData/AddNetworkAccount"),
        meta: { title: "注册网络账号" }
      },
      {
        name: "MailRegistry",
        path: "MailRegistry",
        component: () =>
          import("@/views/Home/Modules/MailRegistry"),
        meta: { title: "注册邮箱" }
      },
      {
        name: "Logout",
        path: "logout",
        component: () => import("@/views/Home/Logout"),
        meta: { title: "退出" }
      },
      ...navRouters,
      {
        name: "NewsDetail",
        path: "newsDetail",
        component: () => import("@/views/NewsNew/NewsDetail"),
        props: (route) =>  route.query,
        meta: { title: "资讯详情" }
      },
      {
        name: "MessagesCenter",
        path: "messages",
        component: () => import("@/views/Messages/index"),
        meta: { title: "消息中心" }
      },
      {
        name: "HelpCenter",
        path: "help",
        component: () => import("@/views/Help/index"),
        meta: { title: "帮助中心" }
      },
      {
        name: "ContentReleaseRedHead",
        path: "ContentReleaseRedHead",
        component: () => import("@/views/BusinessManagement/pages/ContentRelease/redHead"),
        meta: { title: "党政文" }
      },
      {
        name: "BusinessManagementCenter",
        path: "business-management",
        component: () => import("@/views/BusinessManagement/index"),
        meta: { title: "业务管理中心" }
      },
      {
        name: "CreateApplication",
        path: "create-application",
        component: () => import("@/views/BusinessManagement/pages/ApplicationService/form"),
        meta: { title: "创建应用" }
      },
      {
        name: "CreateService",
        path: "create-service",
        component: () => import("@/views/BusinessManagement/pages/ApplicationService/form"),
        meta: { title: "创建服务" }
      },
      {
        name: "EditApplication",
        path: "edit-application",
        component: () => import("@/views/BusinessManagement/pages/ApplicationService/form"),
        meta: { title: "编辑应用" }
      },
      {
        name: "EditService",
        path: "edit-service",
        component: () => import("@/views/BusinessManagement/pages/ApplicationService/form"),
        meta: { title: "编辑服务" }
      },
      {
        name: "ViewApplication",
        path: "view-application",
        component: () => import("@/views/BusinessManagement/pages/ApplicationService/view"),
        meta: { title: "应用详情" }
      },
      {
        name: "ViewService",
        path: "view-service",
        component: () => import("@/views/BusinessManagement/pages/ApplicationService/view"),
        meta: { title: "服务详情" }
      },
      {
        name: "ShelfApplicationService",
        path: "shelf-application-service",
        component: () => import("@/views/BusinessManagement/pages/ApplicationService/shelf"),
        meta: { title: "上架" }
      },
      {
        name: "AddTerminal",
        path: "add-terminal",
        component: () => import("@/views/BusinessManagement/pages/ApplicationService/terminal"),
        meta: { title: "多端管理" }
      },
      {
        name: "ApplicationInfo",
        path: "application-info",
        component: () =>
          import("@/views/BusinessManagement/pages/AppService/ApplicationInfo"),
        meta: { title: "应用信息" }
      },
      {
        name: "DataInfo",
        path: "data-info",
        component: () =>
          import("@/views/BusinessManagement/pages/AppService/DataInfo"),
        meta: { title: "数据管理" }
      },
      {
        name: "DataView",
        path: "data-view",
        component: () =>
          import("@/views/BusinessManagement/pages/FlowData/DataView"),
        meta: { title: "查看数据" }
      },
      {
        name: "DataShareMe",
        path: "data-shareMe",
        component: () =>
          import("@/views/BusinessManagement/pages/FlowData/DataShareMe"),
        meta: { title: "分享给我" }
      },
      {
        name: "GlobalSearch",
        path: "global-search",
        component: () =>
          import("@/views/GlobalSearch/index"),
        meta: { title: "全局搜索" }
      },
      {
        name: "blankData",
        path: "blank-data",
        component: () =>
          import("@/views/PersonalCenter/blank-data"),
        meta: { title: "中转页面" }
      },
      //personal center
      {
        name:"PersonalCenter",
        path:'personal-center',
        component:()=>import("@/views/PersonalCenter"),
        redirect:'/personal-center/information',
        meta: { title: "个人中心" },
        children: [
          {
            name: "Information",
            path: "information",
            component: () =>
              import("@/views/PersonalCenter/information"),
            meta: { title: "账号信息" }
          },
          {
            name: "SafeConfig",
            path: "safe-config",
            component: () =>
              import("@/views/PersonalCenter/safe-config"),
            meta: { title: "安全设置" }
          },
          {
            name: "UnionLogin",
            path: "union-login",
            component: () =>
              import("@/views/PersonalCenter/union-login"),
            meta: { title: "联合登陆" }
          },
          {
            name: "LoginHistory",
            path: "login-history",
            component: () =>
              import("@/views/PersonalCenter/login-history"),
            meta: { title: "登录历史" }
          },
          {
            name: "MyCollections",
            path: "my-collections",
            component: () =>
              import("@/views/PersonalCenter/my-collections"),
            meta: { title: "我的收藏" }
          },
          {
            name: "MyMessage",
            path: "my-message",
            component: () =>
              import("@/views/PersonalCenter/my-message"),
            meta: { title: "我的消息" }
          },


          {
            name: "MyCost",
            path: "my-cost",
            component: () =>
              import("@/views/PersonalCenter/my-cost"),
            meta: { title: "我的费用" }
          },
          {
            name: "addressCard",
            path: "address-card",
            component: () =>
              import("@/views/PersonalCenter/address-card"),
            meta: { title: "通讯录名片" }
          },
          {
            name: "Agent",
            path: "agent",
            component: () =>
              import("@/views/PersonalCenter/agent"),
            meta: { title: "权限待办" }
          },
        ]
      }
    ]
  };
  return ModulesRouter;
}
export {getHomeModulesRouter}  ;


